module.exports = __webpack_public_path__ + "static/img/16.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/16.png
// module id = o7hW
// module chunks = 0